/**
 * Encodage MP3 côté client (lamejs, chargé à la demande).
 * Mono, 192 kbps — largement suffisant pour partager une maquette.
 */
export async function encodeMp3(samples: Float32Array, sampleRate: number): Promise<Blob> {
  const lamejs = await import('@breezystack/lamejs');
  const enc = new lamejs.Mp3Encoder(1, sampleRate, 192);

  // Float32 [-1,1] → Int16
  const pcm = new Int16Array(samples.length);
  for (let i = 0; i < samples.length; i++) {
    const s = Math.max(-1, Math.min(1, samples[i]));
    pcm[i] = Math.round(s * 32767);
  }

  const chunks: Uint8Array[] = [];
  const BLOCK = 1152 * 32;
  for (let i = 0; i < pcm.length; i += BLOCK) {
    const out = enc.encodeBuffer(pcm.subarray(i, i + BLOCK));
    if (out.length) chunks.push(new Uint8Array(out));
  }
  const end = enc.flush();
  if (end.length) chunks.push(new Uint8Array(end));

  return new Blob(chunks as BlobPart[], { type: 'audio/mpeg' });
}
